import { render, staticRenderFns } from "./DerivedCurveLogs.vue?vue&type=template&id=3f3820d6"
import script from "./DerivedCurveLogs.vue?vue&type=script&lang=js"
export * from "./DerivedCurveLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports